<template>
    <span>{{hour ? hourString+':'+minuteString+':'+secondString : minuteString+':'+secondString}}</span>
</template>
<script>
    import fetch from '../libs/fetch'
    export default {
        data () {
            return {
                hour: '',
                minute: '',
                second: '',
                timer: '',
                remainTime:'',
            }
        },

        mounted () {
            this.getNowTime();

        },
        methods: {
            countDowm () {
                var self = this
                clearInterval(this.timer)
                this.timer = setInterval(function () {
                    if (self.hour === 0) {
                        if (self.minute !== 0 && self.second === 0) {
                            self.second = 59
                            self.minute -= 1
                        } else if (self.minute === 0 && self.second === 0) {
                            self.second = 0
                            self.getNowTime();
                            self.$emit('countDownEnd', true)
                            clearInterval(self.timer)
                        } else {
                            self.second -= 1
                        }
                    } else {
                        if (self.minute !== 0 && self.second === 0) {
                            self.second = 59
                            self.minute -= 1
                        } else if (self.minute === 0 && self.second === 0) {
                            self.hour -= 1
                            self.minute = 59
                            self.second = 59
                        } else {
                            self.second -= 1
                        }
                    }
                }, 1000)
            },
            formatNum (num) {
                return num < 10 ? '0' + num : '' + num
            },
            getNowTime(){//获取当前时间
                fetch({
                    url:'/pdd-goods/public/miandan/now',
                    type:"get",
                }).then(res => {
                    this.remainTime = res.data.rest

                    if (this.remainTime > 0) {
                        this.hour = Math.floor((this.remainTime / 3600) % 24)
                        this.minute = Math.floor((this.remainTime / 60) % 60)
                        this.second = Math.floor(this.remainTime % 60)
                        this.countDowm()
                    }

                })
            },
        },
        computed: {
            hourString () {
                return this.formatNum(this.hour)
            },
            minuteString () {
                return this.formatNum(this.minute)
            },
            secondString () {
                return this.formatNum(this.second)
            }
        }
    }
</script>